import { render, staticRenderFns } from "./deliveryMessage.vue?vue&type=template&id=82e4b5f8"
import script from "./deliveryMessage.vue?vue&type=script&lang=js"
export * from "./deliveryMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyaboktober/1088/89/Klettershop5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82e4b5f8')) {
      api.createRecord('82e4b5f8', component.options)
    } else {
      api.reload('82e4b5f8', component.options)
    }
    module.hot.accept("./deliveryMessage.vue?vue&type=template&id=82e4b5f8", function () {
      api.rerender('82e4b5f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/klettershop/deliveryMessage.vue"
export default component.exports